var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"error--text caption text-left mb-5"},[_vm._v(" "+_vm._s(_vm.error)),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }